"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImmotypeLang = getImmotypeLang;
exports.getImmotypeLangKey = getImmotypeLangKey;
exports.getLicenseTypeGroupsLang = getLicenseTypeGroupsLang;

var _ptypes = require("./ptypes.js");

var _license_type_groups = require("./license_type_groups.js");

var _slugify = require("../helpers/slugify");

var _SeoManagerHelpers = require("../helpers/SeoManagerHelpers");

/* TECH-7860 - TRASPASOS */

/* TECH-7860 - TRASPASOS */

/* TECH-7860 - TRASPASOS */

/* TECH-7860 - TRASPASOS */
var FILTER_PROPERTY_VALUES = _ptypes.ptypes_filter.sort(function (a, b) {
  return a.order - b.order;
});
/* TECH-7860 - TRASPASOS */


var FILTER_LICENSE_TYPE_GROUPS_VALUES = _license_type_groups.license_type_groups_filter.sort(function (a, b) {
  return a.order - b.order;
});

var getPlural = function getPlural(value) {
  var isBusiness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var DICT = isBusiness ? _SeoManagerHelpers.LICENSE_TYPE_GROUPS_PLURAL : _SeoManagerHelpers.PROPERTY_TYPES_PLURAL;
  return DICT[value] || value;
};
/* TECH-7860 - TRASPASOS */


var getPluralSlug = function getPluralSlug(value) {
  var isBusiness = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0, _slugify.slugify)(getPlural(value, isBusiness));
};
/* RETURNS ALL IMMOTYPE, CREATED BY THE PTYPES.JSON*/


function getImmotypeLang(IMMOTYPE) {
  FILTER_PROPERTY_VALUES.map(function (el) {
    Object.keys(el.slug).map(function (lang) {
      if (IMMOTYPE[lang]) {
        IMMOTYPE[lang][el.slug[lang]] = {
          key: el.key,
          keys: el.keys.concat([(0, _slugify.slugify)(getPlural(el.slug[lang])), (0, _slugify.slugifyp)(getPlural(el.slug[lang])), getPlural(el.slug[lang]).toLowerCase(), (0, _slugify.slugify)(el.label[lang]), (0, _slugify.slugifyp)(el.label[lang])]),
          keysFor301: el.keysFor301 || [],
          label: el.label[lang],
          label_plural: getPlural(el.slug[lang]),
          slug: el.slug[lang],
          slug_plural: getPluralSlug(el.slug[lang]),
          children: {},
          type: el.type
        };

        if (el.has_children) {
          el.children.map(function (children) {
            var c_slug = children.slug[lang];

            if (!IMMOTYPE[lang][el.slug[lang]].children[c_slug]) {
              IMMOTYPE[lang][el.slug[lang]].children[c_slug] = {};
            }

            IMMOTYPE[lang][el.slug[lang]].children[c_slug] = {
              key: children.key,
              keys: children.keys.concat([(0, _slugify.slugify)(getPlural(children.slug[lang])), (0, _slugify.slugifyp)(getPlural(children.slug[lang])), getPlural(children.slug[lang]).toLowerCase(), getPlural(children.slug[lang]), (0, _slugify.slugify)(children.label[lang]), (0, _slugify.slugifyp)(children.label[lang])]),
              keysFor301: children.keysFor301 || [],
              label: children.label[lang],
              label_plural: getPlural(children.slug[lang]),
              slug: children.slug[lang],
              slug_plural: getPluralSlug(children.slug[lang]),
              category: children.category
            };
          });
        }
      }
    });
  });
  return IMMOTYPE;
}

function getImmotypeLangKey(IMMOTYPE) {
  FILTER_PROPERTY_VALUES.map(function (el) {
    Object.keys(el.slug).map(function (lang) {
      if (IMMOTYPE[lang]) {
        IMMOTYPE[lang][el.key] = {
          label: el.label[lang],
          label_plural: getPlural(el.slug[lang]),
          slug: el.slug[lang],
          slug_plural: getPluralSlug(el.slug[lang]),
          children: {}
        };

        if (el.has_children) {
          el.children.map(function (children) {
            var c_key = children.key;

            if (!IMMOTYPE[lang][el.key].children[c_key]) {
              IMMOTYPE[lang][el.key].children[c_key] = {};
            }

            IMMOTYPE[lang][el.key].children[c_key] = {
              label: children.label[lang],
              label_plural: getPlural(children.slug[lang]),
              slug: children.slug[lang],
              slug_plural: getPluralSlug(children.slug[lang])
            };
          });
        }
      }
    });
  });
  return IMMOTYPE;
}
/* TECH-7860 - TRASPASOS */


function getLicenseTypeGroupsLang(LICENCE_TYPE_GROUP) {
  FILTER_LICENSE_TYPE_GROUPS_VALUES.map(function (el) {
    Object.keys(el.slug).map(function (lang) {
      if (LICENCE_TYPE_GROUP[lang]) {
        LICENCE_TYPE_GROUP[lang][el.slug[lang]] = {
          key: el.key,
          keys: el.keys.concat([(0, _slugify.slugify)(getPlural(el.slug[lang], true)), (0, _slugify.slugifyp)(getPlural(el.slug[lang], true)), getPlural(el.slug[lang], true).toLowerCase(), (0, _slugify.slugify)(el.label[lang]), (0, _slugify.slugifyp)(el.label[lang])]),
          keysFor301: el.keysFor301 || [],
          label: el.label[lang],
          label_plural: getPlural(el.slug[lang], true),
          slug: el.slug[lang],
          slug_plural: getPluralSlug(el.slug[lang], true),
          custom_slug: el.custom_slug ? el.custom_slug[lang] || null : null
        };
      }
    });
  });
  return LICENCE_TYPE_GROUP;
}
/* TECH-7860 - TRASPASOS */